import { Component, OnInit } from '@angular/core';
import { FooterService } from 'src/app/services/components/footer/footer.service';

interface FooterLink {
  id: number;
  section_id: number;
  label: string;
  url: string;
  icon?: string | null;
  target?: string | null;
  is_external?: boolean;
  display_order?: number;
  is_active?: boolean;
  children?: FooterLink[];
}

interface FooterSection {
  id: number;
  title: string;
  slug: string;
  description?: string | null;
  display_order?: number;
  is_active?: boolean;
  links: FooterLink[];
}

interface SocialLink {
  id: number;
  label: string;
  icon?: string | null;
  url: string;
  display_order?: number;
  is_active?: boolean;
}

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {

  public currentYear: number;
  public sections: FooterSection[] = [];
  public socialLinks: SocialLink[] = [];

  constructor(private footerService: FooterService) {
    this.currentYear = new Date().getFullYear();
  }

  ngOnInit(): void {
    this.loadFooterContent();
  }

  loadFooterContent(): void {
    this.footerService.getFooterMenus().subscribe({
      next: (res: any) => {
        const payload = res?.data ?? res;
        const sections: FooterSection[] = ([...(payload?.sections as FooterSection[] ?? [])])
          .map((section: FooterSection) => ({
            ...section,
            links: [...(section.links ?? [])].sort((a: FooterLink, b: FooterLink) => Number(a.display_order ?? 0) - Number(b.display_order ?? 0))
          }))
          .sort((a: FooterSection, b: FooterSection) => Number(a.display_order ?? 0) - Number(b.display_order ?? 0));

        this.sections = sections;
        this.socialLinks = ([...(payload?.social_links as SocialLink[] ?? [])])
          .sort((a: SocialLink, b: SocialLink) => Number(a.display_order ?? 0) - Number(b.display_order ?? 0));
      },
      error: (error) => {
        console.error('Failed to load footer content', error);
      }
    });
  }

  trackSection = (_: number, section: FooterSection) => section.id;
  trackLink = (_: number, link: FooterLink) => link.id;
  trackSocial = (_: number, social: SocialLink) => social.id;
}
